import React, { useRef, useState } from "react";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import CampaignMessageComposer from "../../components/CampaignMessageComposer";
import { fillNegocioMessage, NEGOCIO_MESSAGE_VARS, publicFileUrl, whatsappPreviewHtml } from "./helpers";
import { tNegocio } from "./shared";
import { useStyles } from "./styles";

const BOUNDED_BOX = 300;

export function NegocioPreview({ text, imageUrl, variables = [] }) {
  const classes = useStyles();
  let sample = String(text || "");
  variables.filter(item => item.sample != null).forEach(item => {
    sample = sample.split(`{{${item.key}}}`).join(item.sample);
  });
  const filled = fillNegocioMessage(sample);
  return (
    <div className={classes.previewBubble}>
        {imageUrl ? (
          <img
            className={classes.previewMedia}
            src={publicFileUrl(imageUrl) || imageUrl}
            alt=""
          />
        ) : null}
        {filled ? (
          <span dangerouslySetInnerHTML={{ __html: whatsappPreviewHtml(filled) }} />
        ) : (
          <span style={{ opacity: 0.6 }}>{tNegocio("pages.settings.previewEmpty")}</span>
        )}
    </div>
  );
}

export default function NegocioMessageEditor({
  value = "",
  onChange,
  label,
  placeholder,
  showAttach = false,
  mediaUrl,
  onMedia,
  preview = true,
  rows = 6,
  bounded = false,
  showVars = true,
  varChips,
  attachAccept = "image/*,video/*,application/pdf",
}) {
  const classes = useStyles();
  const fileRef = useRef(null);
  const composerRef = useRef(null);
  const previewRef = useRef(null);
  const [showPreview, setShowPreview] = useState(true);
  const chips = showVars === false ? [] : varChips || NEGOCIO_MESSAGE_VARS;
  const grow = preview && !bounded;

  const syncPreview = (event) => {
    const from = event.target;
    const to = previewRef.current;
    if (!from || !to) return;
    const fromRoom = from.scrollHeight - from.clientHeight;
    const toRoom = to.scrollHeight - to.clientHeight;
    to.scrollTop = fromRoom > 0 ? (from.scrollTop / fromRoom) * toRoom : 0;
  };

  const insertVar = (item) => {
    const token = item.text || `{{${item.key}}}`;
    if (composerRef.current?.insertText) {
      composerRef.current.insertText(token);
      return;
    }
    onChange(`${value || ""}${token}`);
  };

  return (
    <div>
      {label ? (
        <div className={classes.sectionTitle} style={{ marginTop: 8 }}>
          {label}
        </div>
      ) : null}
      {chips.length ? (
        <div className={classes.varRow}>
          {chips.map((item) => (
            <Chip
              key={item.key}
              size="small"
              clickable
              label={`+ ${item.label}`}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => insertVar(item)}
              style={{ backgroundColor: item.color || "#0284c7", color: "#fff", fontWeight: 700 }}
            />
          ))}
        </div>
      ) : null}
      <div
        className={preview ? `${classes.messagePair}${bounded ? ` ${classes.messagePairBounded}` : ""}` : undefined}
        style={bounded ? { "--msg-h": `${BOUNDED_BOX}px` } : undefined}
      >
        <div className={preview ? classes.messageCol : undefined}>
          <CampaignMessageComposer
            ref={composerRef}
            value={value || ""}
            onChange={onChange}
            placeholder={placeholder || tNegocio("pages.settings.messagePlaceholder")}
            rows={grow ? Math.max(rows, String(value || "").split("\n").length) : rows}
            maxLength={4000}
            allowVariables={false}
            showAttach={showAttach}
            fillHeight={bounded}
            autoGrow={grow}
            onInputScroll={bounded ? syncPreview : undefined}
            onAttach={() => fileRef.current && fileRef.current.click()}
          />
          {showAttach ? (
            <input
              ref={fileRef}
              type="file"
              accept={attachAccept}
              hidden
              onChange={(e) => {
                const file = e.target.files && e.target.files[0];
                e.target.value = "";
                if (file && onMedia) onMedia(file);
              }}
            />
          ) : null}
        </div>
        {preview ? (
          <div className={classes.messageCol}>
            <div className={classes.previewCard}>
              <button type="button" className={classes.previewToggle} onClick={() => setShowPreview((v) => !v)}>
                {tNegocio("pages.settings.preview")}
              </button>
              <div ref={previewRef} className={bounded ? classes.previewScroll : classes.previewFlow}>
                {showPreview ? <NegocioPreview text={value} imageUrl={mediaUrl} variables={chips} /> : null}
              </div>
            </div>
          </div>
        ) : null}
      </div>
      {mediaUrl ? (
        <div className={classes.captionBlock} style={{ marginTop: 8 }}>
          {tNegocio("pages.settings.attached")}
          <Button size="small" onClick={() => onMedia && onMedia(null)}>
            {tNegocio("pages.settings.removeMedia")}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
